import { useIntl } from "react-intl";

import { SubmitButton } from "../common/submit-button";

export const NewUserSubmitButton = () => {
    const intl = useIntl();

    // submitting for new translations
    //@ts-ignore
    const newSubmitMessage = intl.formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });

    const submitMessage = intl.formatMessage({
        id: "BxpUiSignup.nameSite.continueButton",
        defaultMessage: "Continue"
    });

    return <SubmitButton submitMessage={submitMessage} />;
};
